import { render } from "./Multiselect.vue?vue&type=template&id=3944e934&ts=true&lang=pug"
import script from "./Multiselect.vue?vue&type=script&setup=true&lang=ts"
export * from "./Multiselect.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__